import React from "react";
import Button from "react-bootstrap/Button";

function PrimaryButton({ text, icon, id, onClick, disabled, style, classname }) {
  return (
    <>
      <style type="text/css">
        {`
          .btn-primary {
            background: linear-gradient(45deg, #070097 0%, #211AFB 100%);
            color: white;
            padding: 12px 20px;
            font-size: 16px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
          }
          .btn-primary:hover {
            transition: 0.5s;
            // transform: scale(1.1);
          }
        `}
      </style>

      <Button
        variant="primary"
        id={id}
        onClick={onClick}
        disabled={disabled}
        className={classname}
        style={{ ...style,
          background: disabled ? "grey" : null,
          borderWidth: disabled ? 0 : null,
        }}
      >
        {icon && <img src={icon} width="16" className="pe-1" alt={`${icon}`} />}
        {text}
      </Button>
    </>
  );
}

export default PrimaryButton;
